import "lazysizes";

export default function () {
	let i;
	let elementos;
	elementos = $(".Games-categorylist--four ul");
	for (i = 4; i <= elementos.length; i++) {
		let elem4 = $(elementos[i - 4]).offset();
		if (elem4 === undefined) {
			elem4 = { top: 0 };
		}
		let elem = $(elementos[i]).offset();
		if (elem === undefined) {
			elem = { top: 0 };
		}
		const distancia = elem4.top + $(elementos[i - 4]).outerHeight() - elem.top;
		$(elementos[i]).css("margin-top", distancia);
	}
}
